// import Swiper from 'swiper/bundle';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Thumbs, Autoplay, Virtual } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Thumbs, Autoplay, Virtual ]);

var swiper = new Swiper(".brands", {
    spaceBetween: 10,
    slidesPerView: 2,
    freeMode: true,
    loop: true,
    loopedSlides: 8,
    watchSlidesProgress: true,
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 3,
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 4,
        },
        992: {
            slidesPerView: 4,
        },
        1280: {
            slidesPerView: 6,
        },
        1400: {
            slidesPerView: 8,
        },
    },
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    },
});
